import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';

const NAV_ITEMS = [
  {
    section: 'Principal',
    items: [
      { to: '/', label: 'Dashboard', icon: 'bi-speedometer2', end: true },
    ],
  },
  {
    section: 'Inventario',
    items: [
      { to: '/productos', label: 'Productos', icon: 'bi-box-seam' },
      { to: '/sucursales', label: 'Sucursales', icon: 'bi-building' },
    ],
  },
  {
    section: 'Operaciones',
    items: [
      { to: '/crear-traslado', label: 'Crear Traslado', icon: 'bi-send' },
      { to: '/stand-movil', label: 'Stand Móvil', icon: 'bi-shop-window' },
      { to: '/facturacion', label: 'Facturación', icon: 'bi-receipt' },
      { to: '/pantalla', label: 'Pantalla', icon: 'bi-display', newTab: true },
      { to: '/ajustes', label: 'Ajustes', icon: 'bi-sliders' },
    ],
  },
  {
    section: 'Consultas',
    items: [
      { to: '/inventario', label: 'Inventario', icon: 'bi-clipboard-data' },
      { to: '/traslados', label: 'Traslados', icon: 'bi-arrow-left-right' },
    ],
  },
];

export default function Sidebar({ isOpen, onClose }) {
  const [collapsed, setCollapsed] = useState({});

  const toggleSection = (section) => {
    setCollapsed((prev) => ({ ...prev, [section]: !prev[section] }));
  };

  return (
    <>
      {isOpen && (
        <div
          onClick={onClose}
          className="sidebar-overlay"
          style={{
            position: 'fixed', inset: 0,
            background: 'rgba(0,0,0,0.65)',
            zIndex: 99,
          }}
        />
      )}

      <nav
        className={`orig-sidebar ${isOpen ? 'open' : ''}`}
        style={{
          width: 'var(--orig-sidebar-w)',
          background: 'var(--orig-dark)',
          borderRight: '1px solid var(--orig-border)',
          height: '100vh',
          position: 'fixed',
          left: 0, top: 0,
          display: 'flex',
          flexDirection: 'column',
          zIndex: 100,
          transition: 'transform 0.28s cubic-bezier(.4,0,.2,1)',
        }}
      >
        {/* Logo */}
        <div style={{
          padding: '22px 18px 18px',
          borderBottom: '1px solid var(--orig-border)',
          display: 'flex', alignItems: 'center', gap: 12,
        }}>
          <div style={{
            width: 40, height: 40,
            background: 'var(--orig-green)',
            borderRadius: 10,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontWeight: 800, fontSize: 18, color: '#fff',
            fontFamily: 'var(--orig-font-display)',
            boxShadow: '0 4px 14px rgba(5,150,105,0.35)',
            flexShrink: 0,
          }}>O</div>
          <div style={{ lineHeight: 1.15 }}>
            <div style={{
              fontSize: 13.5, fontWeight: 700, letterSpacing: 1.5,
              color: 'var(--orig-text)', fontFamily: 'var(--orig-font-display)',
            }}>
              ORÍGENES
            </div>
            <div style={{ fontSize: 10, color: 'var(--orig-text-muted)', letterSpacing: 0.5 }}>
              Control de Inventario
            </div>
          </div>
        </div>

        {/* Nav Items */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '10px 0' }}>
          {NAV_ITEMS.map(({ section, items }) => {
            const isCollapsed = !!collapsed[section];
            return (
              <div key={section}>
                <button
                  type="button"
                  onClick={() => toggleSection(section)}
                  style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    width: '100%',
                    fontSize: 10, color: 'var(--orig-text-hint)',
                    letterSpacing: 2, textTransform: 'uppercase',
                    padding: '10px 20px 4px', fontWeight: 700,
                    background: 'transparent', border: 'none', cursor: 'pointer',
                  }}
                >
                  {section}
                  <i
                    className="bi bi-chevron-down"
                    style={{
                      fontSize: 10,
                      transition: 'transform 0.15s',
                      transform: isCollapsed ? 'rotate(-90deg)' : 'rotate(0deg)',
                    }}
                  />
                </button>
                {!isCollapsed && items.map(({ to, label, icon, end, newTab }) => newTab ? (
                  // Se abre en otra pestaña (p. ej. la pantalla de cocina en una tablet)
                  <a
                    key={to}
                    href={`#${to}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={onClose}
                    style={{
                      display: 'flex', alignItems: 'center', gap: 11,
                      padding: '10px 20px',
                      textDecoration: 'none',
                      fontSize: 13.5,
                      color: 'var(--orig-text-muted)',
                      borderLeft: '3px solid transparent',
                      transition: 'all 0.15s',
                      margin: '1px 0',
                    }}
                  >
                    <i className={`bi ${icon}`} style={{ fontSize: 17, width: 20, flexShrink: 0 }} />
                    {label}
                    <i className="bi bi-box-arrow-up-right" style={{ fontSize: 11, marginLeft: 'auto', opacity: 0.7 }} />
                  </a>
                ) : (
                  <NavLink
                    key={to}
                    to={to}
                    end={end}
                    onClick={onClose}
                    style={({ isActive }) => ({
                      display: 'flex', alignItems: 'center', gap: 11,
                      padding: '10px 20px',
                      textDecoration: 'none',
                      fontSize: 13.5,
                      color: isActive ? 'var(--orig-text)' : 'var(--orig-text-muted)',
                      borderLeft: `3px solid ${isActive ? 'var(--orig-green)' : 'transparent'}`,
                      background: isActive ? 'var(--orig-green-dim)' : 'transparent',
                      transition: 'all 0.15s',
                      margin: '1px 0',
                    })}
                  >
                    <i className={`bi ${icon}`} style={{ fontSize: 17, width: 20, flexShrink: 0 }} />
                    {label}
                  </NavLink>
                ))}
              </div>
            );
          })}
        </div>

      </nav>
    </>
  );
}
